<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <div class="vm-search" style="height: 5vh;">
        <vm-search label="物料号">
          <el-input v-model.trim="filter.materialNo" clearable/>
        </vm-search>
        <el-button
            type="primary"
            :loading="loading"
            size="mini"
            style="height: 26px; margin-left: 10px; padding: 0 8px"
            @click="getData">
          查询
        </el-button>
      </div>
      <el-table
          height="36vh"
          :data="tableData"
          style="width: 100%"
          @row-click="rowClick">
        <el-table-column prop="batchNo" align="center" label="批次号" width="120"/>
        <el-table-column prop="materialNo" align="center" label="物料号" width="100"/>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料描述"
            show-overflow-tooltip/>
        <el-table-column prop="quantity" align="center" label="本批总数" width="100"/>
        <el-table-column prop="miniPackageQuantity" align="center" label="最小包装数量" width="100"/>
        <el-table-column prop="boxQuantity" align="center" label="箱标准数量" width="100"/>
        <el-table-column prop="warehouseNo" align="center" label="仓位号" width="100"/>
        <el-table-column prop="gysCode" align="center" label="供应商代码" width="100"/>
        <el-table-column prop="gysName" align="center" label="供应商名称" width="200"/>
        <el-table-column prop="productionDate" align="center" label="生产日期" width="120"/>
        <el-table-column prop="expirationDate" align="center" label="失效日期" width="120"/>
      </el-table>
      <div style="width: 100%; height: 40vh; margin-top: 6vh;">
        <div style="margin-left: 10%;">
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">物料号： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.materialNo" style="width: 100%;" :disabled="entity.pkid > 0 ? true : false"
                        @change="getMaterial"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">物料描述： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.materialName" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">本批总数： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.quantity" style="width: 100%;" @change="quantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">仓位号： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.warehouseNo" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">最小包装标准数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.miniPackageQuantity" style="width: 100%;" @change="miniPackageQuantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">最小包装标签数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.miniPackageLabelQuantity" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">箱标准数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.boxQuantity" style="width: 100%;" @change="boxQuantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">箱标签数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.boxLabelQuantity" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">供应商代码： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.gysCode" style="width: 100%;"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">供应商名称： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.gysName" style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">生产日期： </span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                  v-model="entity.productionDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%;"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">失效日期： </span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                  v-model="entity.expirationDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">备注： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="entity.note" style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px; margin-left: 20%;">
            <el-col :span="2">
              <el-button
                  v-if="editAuth"
                  type="primary"
                  style="float: right"
                  :loading="submitLoading"
                  @click="save">
                保存
              </el-button>
            </el-col>
            <el-col :span="2">
              <el-button
                  type="primary"
                  style="float: right"
                  @click="emptyInput">
                清空
              </el-button>
            </el-col>
            <el-col :span="8">
              <div style="display: flex;text-align: center;margin-left: 10px;">
                <el-button
                    v-if="printAuth"
                    type="success"
                    :loading="printLoading"
                    @click="printLabel(1)">
                  打印小标签
                </el-button>
                <el-button
                    v-if="printAuth"
                    type="success"
                    :loading="printLoading"
                    @click="printLabel1()">
                  打印小标签V2
                </el-button>
              </div>
            </el-col>
            <el-col :span="4">
              <el-button
                  v-if="printAuth"
                  type="success"
                  style="float: right"
                  :loading="printLoading"
                  @click="printLabel(2)">
                打印箱标签
              </el-button>
            </el-col>
          </el-row>
        </div>
        <print-label-list ref="printLabel"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import PrintLabelList from "@/views/LabelPrinting/PrintLabelList";

  export default {
    name: "InitPrinting",
    components: {VmSearch, PrintLabelList},
    data() {
      return {
        editAuth: true,
        printAuth: true,
        loading: false,
        submitLoading: false,
        printLoading: false,
        filter: {
          materialNo: "",
        },
        tableData: [],
        entity: {
          pkid: null,
          batchNo: null,
          materialType: 1,
          quantity: null,
          miniPackageQuantity: null,
          miniPackageLabelQuantity: null,
          boxQuantity: null,
          boxLabelQuantity: null,
          tailBoxQuantity: null,
          warehouseNo: null,
          productionDate: null,
          expirationDate: null,
          materialNo: null,
          materialName: null,
          gysCode: null,
          gysName: null,
          note: "",
        },
      };
    },
    methods: {
      getData() {
        this.editAuth = this.$auth(387);
        this.printAuth = this.$auth(388);
        if (this.filter.materialNo) {
          this.loading = true;
          this.$http
              .get("basic", "labelPrintingBatches/list/" + this.filter.materialNo)
              .then(resp => {
                this.tableData = resp.data;
                this.loading = false;
              }).catch(() => {
            this.loading = false;
          });
        } else {
          this.tableData = [];
          this.entity = this.$options.data().entity;
        }
      },
      rowClick(row) {
        this.entity = Object.assign(this.entity, row);
      },
      getMaterial() {
        if (this.entity.materialNo) {
          this.$http
              .get("basic", "materials/no/" + this.entity.materialNo)
              .then(resp => {
                if (resp) {
                  console.log(resp);
                  this.entity.materialName = resp.data.materialName;
                  this.entity.warehouseNo = resp.data.warehouseLocationNo;
                }
              });
        } else {
          this.entity.materialName = "";
          this.entity.warehouseNo = "";
        }
      },
      quantityChange() {
        if (this.entity.quantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.entity.quantity > 0 && this.entity.miniPackageQuantity > 0) {
          this.entity.miniPackageLabelQuantity = Math.ceil(this.entity.quantity / this.entity.miniPackageQuantity);
        }
        if (this.entity.quantity > 0 && this.entity.boxQuantity > 0) {
          this.entity.boxLabelQuantity = Math.ceil(this.entity.quantity / this.entity.boxQuantity);
          this.entity.tailBoxQuantity = (this.entity.quantity % this.entity.boxQuantity) == 0 ? this.entity.boxQuantity : (this.entity.quantity % this.entity.boxQuantity);
        }
      },
      miniPackageQuantityChange() {
        if (this.entity.miniPackageQuantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.entity.quantity > 0 && this.entity.miniPackageQuantity > 0) {
          this.entity.miniPackageLabelQuantity = Math.ceil(this.entity.quantity / this.entity.miniPackageQuantity);
        }
      },
      boxQuantityChange() {
        if (this.entity.boxQuantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.entity.quantity > 0 && this.entity.boxQuantity > 0) {
          this.entity.boxLabelQuantity = Math.ceil(this.entity.quantity / this.entity.boxQuantity);
          this.entity.tailBoxQuantity = (this.entity.quantity % this.entity.boxQuantity) == 0 ? this.entity.boxQuantity : (this.entity.quantity % this.entity.boxQuantity);
        }
      },
      save() {
        if (!this.entity.materialNo ||
            !this.entity.quantity ||
            !this.entity.miniPackageQuantity ||
            !this.entity.boxQuantity ||
            !this.entity.productionDate ||
            !this.entity.expirationDate) {
          this.$message.error("请完善数据");
          return;
        }
        this.submitLoading = true;
        this.$http
            .save("basic", "labelPrintingBatches", this.entity)
            .then((res) => {
              if (res) {
                this.entity.pkid = res.data;
                this.filter.materialNo = this.entity.materialNo;
                this.getData();
              }
              this.submitLoading = false;
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
      },
      printLabel(type) {
        if (!this.entity.pkid) {
          this.$message.error("选择批次号再打印");
          return;
        }
        this.printLoading = true;
        this.$http
            .postForFile("basic", "labelPrintingBatches/printLabel/" + type + "/" + this.entity.pkid)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              window.open(pdfUrl);
              this.printLoading = false;
            }).catch(() => {
          this.printLoading = false;
          this.$message.error("获取打印信息失败");
        });
      },
      printLabel1() {
        if (!this.entity.pkid) {
          this.$message.error("选择批次号再打印");
          return;
        }
        this.printLoading = true;
        this.$http
            .post("basic", "labelPrintingBatches/getLabel/" + this.entity.pkid)
            .then((res) => {
              if (res.success) {
                res.data.forEach((item) => {
                  item.showCode = item.materialNo + "-" + item.serialNumber.substring(item.serialNumber.length - 12) + "-" + item.quantity;
                });
                this.$refs.printLabel.open(res.data);
              } else {
                this.$message.error(res.message);
              }
              this.printLoading = false;
            }).catch(() => {
          this.printLoading = false;
          this.$message.error("获取打印信息失败");
        });
      },
      emptyInput() {
        this.entity = this.$options.data().entity;
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
